import { render, staticRenderFns } from "./stayinguser-page.vue?vue&type=template&id=d61c7ae0&scoped=true"
import script from "./stayinguser-page.vue?vue&type=script&lang=js"
export * from "./stayinguser-page.vue?vue&type=script&lang=js"
import style0 from "./stayinguser-page.vue?vue&type=style&index=0&id=d61c7ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61c7ae0",
  null
  
)

export default component.exports